import angular from 'angular';

export default angular.module('billingApiModule', []);



// WEBPACK FOOTER //
// ./modules/billingApi/billingApi.module.js